import type { SupplementalSectionProps } from '../../../../../ApplicationEdit/Sections/7Supplemental/supplementalSections';
import { hasContactDetails } from '../../../../../../utils/capps-mappers';
import { ContactOverview } from './ContactOverview';

export function EmergencyContactOverview({ answers }: SupplementalSectionProps) {
  const contact = answers.emergencyContact;

  return hasContactDetails(contact) && <ContactOverview title="Emergency contact" contact={contact} hasRelationship />;
}
